import { createFileRoute } from '@tanstack/react-router';

import { ProcessesTable } from '@/components/processes/table/ProcessesTable';
import { useProcessesQuery } from '@/queries/useProcessesQuery';

function ProcessesRoute() {
  const { data, isFetching } = useProcessesQuery();

  return <ProcessesTable data={data} isFetching={isFetching} />;
}

export const Route = createFileRoute('/_authenticated/_management/vorgaenge/')({
  component: ProcessesRoute,
});
